var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fc-top"},[_c('div',{staticClass:"tabList"},_vm._l((_vm.tabList),function(item,index){return _c('span',{key:index,staticClass:"tabItem",class:{'curStyle':item.id==_vm.curId},on:{"click":function($event){return _vm.setNav(item)}}},[_vm._v(_vm._s(_vm.$t(item.name)))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }